import { Box } from '../../../components/MuiGenerals';
import ToggleFilterButton from '../components/Filters/CollapsibleFilters/components/ToggleFilterButton';
import ActionButtons from '../components/Filters/CollapsibleFilters/components/ActionButtons';
interface IFilterSectionActionRow {
  isCollapse: boolean;
  toggleFilterCollapse?: () => void;
  onSearch: () => void;
  onReset: () => void;
}

const FilterSectionActionRow = (props: IFilterSectionActionRow) => {
  const { isCollapse, toggleFilterCollapse, onSearch, onReset } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '24px 0',
      }}
    >
      <ToggleFilterButton isCollapse={isCollapse} onClick={toggleFilterCollapse} />
      <ActionButtons onSearch={onSearch} onReset={onReset} />
    </Box>
  );
};

export default FilterSectionActionRow;
